class FireAnalyticsEventModel {
  response = {
    app_name: "in.workindia.wibotjs",
    identifier: null,
    event_name: null,
    timestamp: null,
    attributes: {},
  };
}

export default new FireAnalyticsEventModel();
